<template>
  <div class="flex flex-row" style="position: fixed; z-index:1; width: 880px;">
    <app-table v-bind="$attrs" class="table-auto w-full">
      <template v-slot:table-body>
        <tr
          class="border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-12"
          v-for="(header, index) in rejectHeaders"
          :key="index"
        >
          <template v-if="rejected(header.attr)">
            <td width="185px" class="rejected-line">
              <div class="flex flex-row items-center cursor-pointer">
                <RejectedIcn width="20px" height="20px" class="ml-3 mr-1" />
                <span class="text-lg text-red font-bold">
                  {{ header.title }}
                </span>
              </div>
              <div
                class="flex flex-row items-center cursor-pointer mt-4"
                @click="rejectToggleAttr(header)"
              >
                <RejectCancelIcn class="ml-3 mr-1" />
                <div class="flex flex-row items-baseline">
                  <span class="text-sm text-red font-bold">
                    差戻し
                  </span>
                  <span class="text-lg text-red font-bold">
                    解除
                  </span>
                </div>
              </div>
            </td>
            <td class="rejected-line pr-3" style="height: 93px">
              <span
                class="text-lg text-red block"
                :id="`reason-comment-${header.attr}`"
                @click="showReasonInput(header.attr)"
                v-show="false"
              >
                {{
                  header.comment.length
                    ? header.comment
                    : '※ コメントはありません'
                }}
              </span>
              <AppTextInput
                color="red"
                class="text-red"
                placeholder="コメントを入力ください"
                v-model="header.comment"
                @blur="onBlur(header)"
                :id="`reason-input-${header.attr}`"
                v-show="true"
              ></AppTextInput>

              <span v-if="header.attr == 'period'" class="text-lg">
                {{ $filters.dateFormat(currentPoliticalAction['startDate']) }}
                〜
                {{ $filters.dateFormat(currentPoliticalAction['endDate']) }}｜
                {{ $filters.wareki(currentPoliticalAction['startDate']) }}
                ～ {{ $filters.wareki(currentPoliticalAction['endDate']) }}
              </span>
              <span class="text-lg" v-else-if="header.attr == 'actionTypes'">
                {{
                  actionTypeNames(currentPoliticalAction['selectedActionTypes'])
                }}
              </span>
              <span class="text-lg" v-else-if="header.attr == 'submissionDate'">
                {{
                  $filters.dateFormat(currentPoliticalAction['submissionDate'])
                }}
              </span>

              <span v-else class="text-lg">{{
                currentPoliticalAction[header.attr]
              }}</span>
            </td>
          </template>

          <template v-else>
            <td width="185px">
              <div
                class="flex flex-row items-center cursor-pointer"
                @click="rejectToggleAttr(header)"
              >
                <RejectIcn width="20px" height="20px" class="ml-3 mr-1" />
                <span class="text-lg text-blue font-bold">
                  {{ header.title }}
                </span>
              </div>
            </td>
            <td v-if="header.attr == 'period'">
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />
              <span class="text-lg">
                {{ $filters.dateFormat(currentPoliticalAction['startDate']) }}
                〜
                {{ $filters.dateFormat(currentPoliticalAction['endDate']) }}｜
                {{ $filters.wareki(currentPoliticalAction['startDate']) }}
                ～ {{ $filters.wareki(currentPoliticalAction['endDate']) }}
              </span>
            </td>
            <td v-else-if="header.attr == 'actionTypes'">
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />
              {{
                actionTypeNames(currentPoliticalAction['selectedActionTypes'])
              }}
            </td>
            <td v-else-if="header.attr == 'submissionDate'">
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />
              <span class="text-lg">
                {{
                  $filters.dateFormat(currentPoliticalAction['submissionDate'])
                }}
              </span>
            </td>
            <td v-else-if="header.attr == 'files'">
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />
              <span class="text-lg">
                <div
                  v-for="(img, index) in currentPoliticalAction.application
                    .images"
                  :key="index"
                >
                  <span :class="`text-red mb-1 ml-1`"
                    >※画像クリックで黒塗りダイアログが開きます</span
                  >
                  <img
                    v-if="img.normalImage"
                    :src="
                      img.blackImage == null ? img.normalImage : img.blackImage
                    "
                    @click="
                      openImgPreview('request', index, {
                        normalImage: img.normalImage,
                        blackImage: img.blackImage,
                      })
                    "
                  />
                </div>
              </span>
            </td>
            <td v-else>
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />{{ currentPoliticalAction[header.attr] }}
            </td>
          </template>
        </tr>
      </template>
    </app-table>
  </div>
</template>

<script>
import { nextTick, reactive } from 'vue'

import AppTable from '@/components/ui/AppTable'
import AppTextInput from '@/components/ui/AppTextInput'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import RejectIcn from '@/assets/icons/reject.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import RejectCancelIcn from '@/assets/icons/reject-cancel.svg?inline'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useRequestReject } from '@/services/politicalAction/useRequestReject'
import { useDialog } from '@/services/useDialog'
import { useRequestForm } from '@/services/politicalAction/useRequestForm'

export default {
  name: 'RequestOffice',

  components: {
    AppTable,
    AppTextInput,
    AppPreviewSentBackItem,
    RejectIcn,
    RejectedIcn,
    RejectCancelIcn,
  },

  setup() {
    let { rejectHeaders, rejectedAttrs } = useRequestReject()

    let imgPreviewState = reactive({ isShown: false, previewImgSrc: null })

    const { currentPoliticalAction, actionTypeNames } = usePoliticalActions()

    const isShowImgPreview = src => {
      imgPreviewState.isShown = true
      imgPreviewState.previewImgSrc = src
    }

    const onBlur = header => {
      let comment = document.getElementById(`reason-comment-${header.attr}`)
      let reasonInput = document.getElementById(`reason-input-${header.attr}`)
      comment.style.display = 'block'
      reasonInput.style.display = 'none'
      header.comment = reasonInput.value
      rejectedAttrs.find(item => item.target == header.attr).comment =
        reasonInput.value
    }

    const rejectToggleAttr = header => {
      const itemIndex = rejectedAttrs.findIndex(
        item => item.target == header.attr,
      )

      if (itemIndex > -1) {
        rejectedAttrs.splice(itemIndex, 1)
        header.comment = ''
        // headers.find((item) => item.attr == attr).comment = "";
      } else {
        rejectedAttrs.push({
          target: header.attr,
          comment: '',
        })
        nextTick(() => {
          document.getElementById(`reason-input-${header.attr}`).focus()
        })
      }
    }

    const rejected = attr => {
      return rejectedAttrs.findIndex(item => item.target == attr) > -1
    }

    const showReasonInput = attr => {
      let comment = document.getElementById(`reason-comment-${attr}`)
      let reasonInput = document.getElementById(`reason-input-${attr}`)
      comment.style.display = 'none'
      reasonInput.style.display = 'block'
      reasonInput.focus()
    }

    return {
      rejectHeaders,
      currentPoliticalAction,
      rejectedAttrs,
      actionTypeNames,
      rejected,
      rejectToggleAttr,
      showReasonInput,
      onBlur,
      isShowImgPreview,
      imgPreviewState,
      ...useDialog(),
      ...useRequestForm(),
    }
  },
}
</script>

<style lang="scss" scoped>
.rejected-line {
  background: theme('colors.red.lightest');
}
td:first-child {
  border-top-left-radius: 22px;
  border-bottom-left-radius: 22px;
}
td:last-child {
  border-top-right-radius: 22px;
  border-bottom-right-radius: 22px;
}
</style>
